// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"126":"8a7e1b52d8e34b60","581":"cbd9ea38191287bb"}[chunkId] + ".css";
};